<div class="help-box-container tw-w-[40vw] sm:tw-w-[100vw] sm:tw-h-[100vh] tw-flex tw-flex-col">
  <div class="tw-flex tw-flex-col tw-h-full">
    <form [formGroup]="supportEnquiry" class="tw-flex tw-flex-col tw-h-full">
      <!-- Top Section -->
      <div class="help-box-top tw-p-8">
        <div class="help-box-header tw-flex tw-justify-between tw-items-center tw-mb-5">
          <span class="tw-text-2xl xs:tw-text-lg">{{ supportBoxHeader }}</span>
          <button (click)="closeHelpBox()" aria-label="Close dialog" tabindex="-1" type="button">
            <icon [name]="'close'" [size]="8" [currentColor]="'color-text-default'"></icon>
          </button>
        </div>

        <div class="tw-flex tw-flex-col tw-gap-4">
          <app-input
            [label]="'firstName' | i18n"
            [placeholder]="'First Name'"
            [isRequired]="true"
            [manualTouched]="supportEnquiry.controls.firstName.touched"
            formControlName="firstName"
            class="tw-w-full"
          >
          </app-input>

          <app-input
            [label]="'lastName' | i18n"
            [placeholder]="'Last Name'"
            formControlName="lastName"
            class="tw-w-full"
          >
          </app-input>

          <app-input
            [label]="'emailAddress' | i18n"
            [placeholder]="'Email'"
            [isRequired]="true"
            [manualTouched]="supportEnquiry.controls.email.touched"
            formControlName="email"
            class="tw-w-full"
          >
          </app-input>

          <div class="tw-flex tw-flex-col tw-gap-1">
            <div class="tw-flex tw-gap-1 tw-font-medium tw-text-color-text-default tw-z-10">
              <span class="tw-whitespace-nowrap">{{ "message" | i18n }}</span>
              <span class="tw-text-sm">*</span>
            </div>
            <div
              [ngClass]="{
                'input-error-border hover:tw-border-color-status-error focus-within:tw-border-color-status-error':
                  supportEnquiry.controls.message.errors?.required &&
                  supportEnquiry.controls.message.touched,
                'tw-shadow-elevation-input': true,
                'tw-cursor-text': true,
              }"
              class="tw-w-full tw-rounded-lg tw-px-6 tw-py-4 tw-bg-color-surface-input"
            >
              <textarea
                id="message"
                name="message"
                formControlName="message"
                required
                placeholder="Enter your message..."
                [rows]="rows"
                class="tw-w-full tw-bg-transparent tw-border-none tw-cursor-text focus:tw-outline-none tw-resize-none"
              ></textarea>
            </div>
            <span
              *ngIf="
                supportEnquiry.controls.message.errors?.required &&
                supportEnquiry.controls.message.touched
              "
              class="tw-whitespace-nowrap tw-text-dt-text-error tw-text-xs"
            >
              {{ "emailRequiredDesc" | i18n }}
            </span>
          </div>
        </div>
      </div>

      <!-- Bottom Section -->
      <div class="help-box-bottom tw-p-8 tw-mt-auto">
        <div class="tw-flex tw-justify-end custom-submit-btn">
          <app-gloss-button
            [options]="{
              class: 'primary',
              text: 'submit' | i18n,
              onClick: sendMessage.bind(this),
              isEnabled: !requestProcessing,
            }"
            [isLoading]="requestProcessing"
            class="sm:tw-w-full tw-w-1/2"
          >
          </app-gloss-button>
        </div>
        <div
          *ngIf="submitClicked && !supportEnquiry.valid"
          class="tw-flex tw-justify-end tw-text-dt-text-error tw-mt-2"
        >
          Don't forget to fill out all the fields
        </div>
        <div *ngIf="webError" class="tw-text-dt-text-error tw-mt-2">
          {{ webError }}
        </div>
      </div>
    </form>
  </div>
</div>
